import { useEffect, useState } from 'react';
import api from '../lib/api';

const cache = {};

export function useOpenStatus(merchantId) {
  const [status, setStatus] = useState(cache[merchantId] || null);
  useEffect(() => {
    if (!merchantId) return undefined;
    let alive = true;
    const load = () => api.get(`/merchants/${merchantId}/status`)
      .then((r) => { cache[merchantId] = r.data; if (alive) setStatus(r.data); })
      .catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [merchantId]);
  return status;
}

export function openStatusFor(merchant, status) {
  const mtype = (merchant?.merchantType || status?.merchantType || 'PRODUCT').toUpperCase();
  const open = status ? status.open : true;
  return { open, type: mtype, opensAt: status?.opensAt, closesAt: status?.closesAt, reason: status?.reason };
}
